import apiWrapper from 'Helpers/apiWrapper'
import extractApiData from 'Helpers/extractApiData'
import { encodeParams, serialize } from 'mailup-react-helpers'

const endpoints = ((baseURL) => {
  return {
    //  List report
    getListDeviceCounters: (idList) =>
      `${baseURL}/api/report/lists/${idList}/device/counters`,
    //
    getMessageTotalCounters(idList, idMessage, types, from, to) {
      const params = { from, to }
      let p = ''
      if (from || to) {
        p = encodeParams(params)
      }
      return `${baseURL}/api/report/lists/${idList}/messages/${idMessage}/totalcounters${serialize(
        types,
        'types',
        '?'
      )}&${p}`
    },
    getMessageSent: (idList, idMessage, params) =>
      `${baseURL}/api/report/lists/${idList}/messages/${idMessage}/totalcounters?${encodeParams(
        params
      )}`,

    // report for specific recipient
    getMessageStatsForSpecificRecipient: (idList, idMessage, params) =>
      `${baseURL}/api/report/lists/${idList}/messages/${idMessage}/recipients/totalcounters?${encodeParams(
        params
      )}`
  }
})(process.env.STATS_URL)

export const statisticsGetMessageTotalCounters = (
  idList,
  idMessage,
  types,
  from,
  to
) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getMessageTotalCounters(idList, idMessage, types, from, to)
  }).then(extractApiData)
}

export const statisticsGetListDeviceCounters = (idList) => {
  const url = endpoints.getListDeviceCounters(idList)
  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const statisticsGetMessageSent = (idList, idMessage, params) => {
  const url = endpoints.getMessageSent(idList, idMessage, params)
  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const statisticsApiGetMessageStatsForSpecificRecipient = (
  idList,
  idMessage,
  params
) => {
  const url = endpoints.getMessageStatsForSpecificRecipient(
    idList,
    idMessage,
    params
  )
  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}
